import AnimatedVisualSwap, { resolveMethodologyAnimation, } from "@frontend/js/Components/Shared/Animation/AnimatedVisualSwap";


export function resolveAnimationIcon(animationId) {
    return resolveMethodologyAnimation(animationId);
}

export default function AnimationIcon({ animationId, className }) {
    const animation = resolveAnimationIcon(animationId);

    if (!animation) {
        return null;
    }

    return (
        <div className={className}>
            <AnimatedVisualSwap animationId={animationId} type="methodology" />
        </div>
    );
}
